var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySpaceAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 372,
    viewBox: "0 0 401 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.846 1.01487C248.782 7.80186 258.925 71.6926 293.368 105.722C328.263 140.198 401.425 149.211 400.491 198.26C399.555 247.462 327.066 255.082 289.911 287.341C257.83 315.195 243.258 369.157 200.846 371.599C157.956 374.069 133.364 326.37 100.9 298.226C63.8782 266.131 5.94496 247.002 0.899013 198.26C-4.27944 148.239 42.014 110.515 77.8112 75.2019C113.255 40.2372 151.555 -5.96408 200.846 1.01487Z",
    fill: "url(#paint0_linear_15621_209738)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_15621_209738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.788 61.2833C246.909 39.2793 321.433 105.878 343.901 189.729C360.697 252.414 292.328 291.696 230.935 308.147C165.872 325.58 80.8596 331.414 63.0588 264.98C39.8309 178.292 79.8892 84.032 164.788 61.2833Z",
    fill: "url(#paint1_linear_15621_209738)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.122 252.963C152.404 252.963 124.262 224.228 124.262 188.779C124.262 153.33 152.404 124.595 187.122 124.595C221.839 124.595 249.982 153.33 249.982 188.779C249.982 224.228 221.839 252.963 187.122 252.963ZM187.122 240.126C200.459 240.126 213.25 234.717 222.681 225.087C232.112 215.458 237.41 202.397 237.41 188.779C237.41 175.161 232.112 162.1 222.681 152.471C213.25 142.841 200.459 137.432 187.122 137.432C173.785 137.432 160.994 142.841 151.563 152.471C142.132 162.1 136.834 175.161 136.834 188.779C136.834 202.397 142.132 215.458 151.563 225.087C160.994 234.717 173.785 240.126 187.122 240.126V240.126ZM180.836 156.687H193.408V169.524H180.836V156.687ZM180.836 182.361H193.408V220.871H180.836V182.361Z",
    fill: "#41435B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_15621_209738",
    x: 48.5469,
    y: 53.0371,
    width: 305.934,
    height: 278.63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15621_209738"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_15621_209738",
    result: "effect2_dropShadow_15621_209738"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_15621_209738",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15621_209738",
    x1: 0.5,
    y1: 186,
    x2: 400.5,
    y2: 186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15621_209738",
    x1: 52.0226,
    y1: 223.792,
    x2: 332.865,
    y2: 148.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15F0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E95FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySpaceAttention);
export default __webpack_public_path__ + "static/media/emptySpaceAttention.4892b56af4473fa855cebd38232eb6fe.svg";
export { ForwardRef as ReactComponent };